import { CourseCard } from '@/components/courses/CourseCard'
import type { ScoredCourse } from '@/lib/needs/recommend-courses'

interface RecommendedCoursesProps {
  recommendations: ScoredCourse[]
  /** Naslov sekcije; podrazumevano "Preporučeno za tebe". */
  heading?: string
  headingId?: string
}

export function RecommendedCourses({
  recommendations,
  heading = 'Preporučeno za tebe',
  headingId = 'recommended-heading',
}: RecommendedCoursesProps) {
  if (recommendations.length === 0) return null

  return (
    <section aria-labelledby={headingId} className="flex flex-col gap-4">
      <h2 id={headingId} className="text-2xl font-semibold">
        {heading}
      </h2>
      <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {recommendations.map(({ course, reasons }) => (
          <li key={course.slug} className="flex flex-col gap-2">
            <CourseCard course={course} />
            {reasons.length > 0 && (
              <ul className="text-muted-foreground flex flex-wrap gap-1.5 px-1 text-xs">
                {reasons.map((reason) => (
                  <li
                    key={reason}
                    className="bg-muted inline-flex items-center rounded-full px-2 py-0.5"
                  >
                    {reason}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </section>
  )
}
